import { Injectable } from '@angular/core';
import { CitaTaller } from '../models/CitaTaller';
import { HttpClient, HttpParams,HttpClientJsonpModule } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RespuestaApiEmail } from '../models/RespuestaApiEmail';
import {AnexoDelegacion} from "../models/AnexoDelegacion";

@Injectable({
  providedIn: 'root'
})

export class EmailService
{

  constructor(private http: HttpClient) { }

  public enviarEmail(token:string, arrParams:any){
    let url:string = environment.emailWSBase + "/api/Email/send"
    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production){
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }

  public enviarEmailHTML(token:string, arrParams:any){
    let url:string = environment.emailWSBase + "/api/Email/sendCitaCliente"
    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production){
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }

  public enviarSMS(token:string, arrParams:any){
    let url:string = environment.emailWSBase + "/api/Email/sendSMSCliente"
    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production){
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }
}
